import Vue from 'vue'
import Vuex from 'vuex'
import { actions } from './actions'
import { mutations } from './mutations'
import { getters } from './getters'

Vue.use(Vuex)

const store = () => new Vuex.Store({
  state: {
    shouldDisplayErrors: false,
    cart: {
      people: [
        {
          id: 1,
          firstName: '',
          lastName: '',
          luggageSmall: 0,
          luggageLarge: 0
        }
      ],
      responsiblePersonId: 1,
      luggageSmall: {
        amount: 1,
        price: 65
      },
      luggageLarge: {
        amount: 0,
        price: 95  /*CKA: changed from 45 */
      },
      luggageAirshell: {
        amount: 0,
        price: 45
      },
      luggagePlasticBag: {
        amount: 0,
        price: 75
      },
      includeHome: false,
      serviceUdrejse: false,
      serviceHjemrejse: false,
      luggageDescription: ''
    },
    booking: {
      //date: new Date(),
      //date: new Date(Date.now()+216000000), //afrejsedag er 2,5 dage fra nu
      //date: new Date(Date.now()+302400000), //afrejsedag er 3,5 dage fra nu
      //date: new Date(Date.now()+691200000), //defalut dato er 8 dage fra nu
      //date: new Date(Date.now()+ 864000000 ), //defalut dato er 10 dage fra nu
      date: null, //defalut dato er 10 dage fra nu
      //date: '',
      
      time: {
        HH: "",
        mm: ""
      },
      destination: null,
      iataCode: null,
      number: null,
      airline: null,
      flightNumber: null,
      travelagency: null,
      travelagencyfinal: null,
      datetimeTouched: false,
    },

    /* PURoadLevel */
    puroadLevel: {
      value: null,
      maxPostalNumber: 2000,
      fee: 150
    },

    bookingHome: {
      dateHome: null,
      timeHome: {
        HH: "12",
        mm: "45"
      },
      flightNumberHome: null,
      commentHome: null,
      customsService: false,
      travelType: 'non-eu',
      isEuTravelOnly: false,
      isNonEuTravel: true,
      departureAirport: null,
      hasTransitStops: null,
      transitStops: [],
      customsAcceptance: false,
      customsValidation: false,
      travelersUnder16: 0,
      travelersAge16: 0,
      travelersAge17: 0,
      travelersAge18Plus: 0,
      customsCode: '',
      customsComment: ''
    },
    contact: {
      phone: {
        prefix: '+45',
        number: ''
      },
      firstName: '',
      lastName: '',
      email: '',
      address: {
        road: '',
        number: '',
        zip: '',
        city: ''
      },
    },
    payment: {
      type: 'Betalingskort',
      coupon: '',
      couponValue: 0,
      couponValueCU: 0,
      couponType: '',
      couponIncludeUdrejse: true,
      couponIncludeHjemrejse: true,
      couponExpirydate: '',
      couponWasExpired: false,
      couponError: false,
      totalPreCoupon: null,
      confirmedAmount: null,
      comment: '',
      statsborgerskab: '',
      termsAccepted: false,
      newsletter: false
    },
    pricing: {
      quoteId: '',
      quoteSignature: '',
      inputHash: '',
      expiresAt: '',
      currency: 'DKK',
      rulesVersion: '',
      priceBreakdown: null,
      lastRequestId: '',
      isLoading: false,
      lastError: ''
    }
  },
  mutations,
  actions,
  getters
})

export default store
